'use strict';
const cleanDOMId = require('./clean-dom-id');
module.exports = function (id) {
	return cleanDOMId('node_' + id);
};
